// Finnish

export default {
  component: {

    supportLink: 'support@recright.com',

    layout: {
      endTime: date => (date ? `vastausaika päättyy ${date}` : ''),
    },
    interview: {
      title: 'Vastaa videohaastatteluun',
      submit: 'Lähetä vastaukset ja päätä haastattelu',
      continueLater: 'Jatka myöhemmin',
      startInterview: 'Aloita haastattelu',
      duplicateError: 'Olet jo osallistunut haastatteluun. Olet saanut osoitteesta invitations@recright.com sähköpostin, jonka kautta pääset jatkamaan haastattelua.',
      confirmSubmitHeader: 'Et ole vastannut kaikkiin haastattelukysymyksiin',
      confirmSubmitContent: 'Haluatko varmasti päättää haastattelun?',
      confirmSubmitContentWarning: 'Tämän jälkeen et pääse enää täydentämään haastatteluvastauksiasi.',
      submitInterviewHeader: 'Lähetä vastauksesi',
      submitInterviewContent: 'Oletko varma että haluat lähettää vastauksesi ja päättää haastattelun?',
      confirmSubmitButton: 'Lähetä vastaukset ja päätä haastattelu',
      preview: 'Tästä voit esikatsella videokysymyksiä.',
      requiredQuestionsNotAnswered: 'Sinun on vastattava kaikkiin pakollisiin kysymyksiin ennen kuin voit lähettää vastauksesi.',
      withdrawLink: 'Etkö ole enää kiinnostunut tästä positiosta? Vetäydy prosessista tässä.',
    },

    personalInterview: {
      title: 'Valitse sopiva aika tapaamiselle',
      description: [
        'Sinut on kutsuttu tapaamiseen.',
        'Valitse aika, joka sopii sinulle parhaiten.',
      ],
      position: 'Position:',
      location: 'Paikka:',
      time: 'Aikka:',
      timezoneNotice: [
        'Otathan huomioon, että tapaamisajat näkyvät aikavyöhykkeesi ajassa.',
        'Aikavyöhykkeesi näyttäisi olevan:',
        'Tapaamisen aikavayöhyke:',
      ],
      success: {
        title: 'Tapaaminen sovittu!',
        description: 'Hienoa! Tapaaminen on nyt sovittu. Tässä vielä tapaamisen tiedot:',
        linkDescription: [
          'Voit lisätä tapaamisen kalenteriisi alapuolelta.',
          'Tai voit kopioida linkin kalenterisovellukseesi:',
        ],
        link: 'Lisää kalenteriisi',
      },
    },

    interviewForm: {
      name: 'Nimi',
      email: 'Sähköposti',
      phone: 'Puhelinnumero',
      city: 'Kaupunki',
      link: 'Linkki',
      legendBasicInfo: 'Perustiedot',
      placeholderName: 'Syötä nimesi',
      placeholderEmail: 'Syötä sähköpostiosoitteesi',
      placeholderPhone: 'Syötä puhelinnumerosi',
      placeholderCity: 'Syötä nykyinen kotikaupunkisi',
      placeholderLink: 'Lisää linkki, esim. LinkedIn -profiilisi',
      legendAttachments: 'Liitetiedostot',
      legendAdditionalFields: 'Lisätietoja',
      required: '* Tähdellä merkityt kentät ovat pakollisia.',
    },

    sequencedInterview: {
      networkTest: {
        audio: 'Ääni',
        video: 'Video',
        supported: 'Tuettu',
        quality: 'Laatu',
        yes: 'Kyllä',
        no: 'Ei',
        header: 'Yhteys- ja laitetesti',
        description: 'Tällä testillä testaamme sekä verkkoyhteytesi että haastatteluun tarvittavan laitteiston (kamera ja mikrofoni) toimivuuden.  Myönnäthän testille oikeudet käyttää mikrofonia ja kameraa kysyttäessä. Testaus kestää noin 30 sekuntia. Varmistat, että olet poistanut mahdolliset suojat kameran edestä. Suosittelemme, että puhut laitteistoa testattaessa.',
        inProgress: 'Testaus käynnissä...',
        networkTestResults: 'Yhteystestin tulokset',
        qualityTestResults: 'Laatutestin tulokset',
        testPassedNetwork: 'Verkkotesti onnistui',
        testFailedNetwork: 'Verkkotesti epäonnistui',
        testPassedQuality: 'Laatutesti onnistui',
        testFailedQuality: 'Laatutesti epäonnistui',
        startTest: 'Aloita testi',
        testAgain: 'Tee testi uudelleen',
        startInterview: 'Aloita haastattelu',
        confirmTitle: 'Olet aloittamassa haastattelusi',
        confirmWarning: 'Kun haastattelu alkaa, siirryt katsomaan ensimmäistä haastattelukysymystä. Kysymyksen katselun jälkeen siirryt automaattisesti valmistautumisnäkymään.',
        confirmText: 'Sinulla on lyhyt aika valmistautua ennen jokaista vastausta. Valmistautumisen jälkeen vastauksen nauhoitus alkaa automaattisesti ja sinulla on ennalta määrätty aika vastata kysymykseen.',
        confirmText2: 'Voit lähettää vastauksesi myös ennen vastausajan päättymistä. Kun vastaus on lähetetty, siirryt seuraavaan kysymykseen.',
        confirmText3: 'Huomioithan, että nauhoituksen päätyttyä sinulla on 30 sekuntia kunnes vastauksesi tallennetaan automaattisesti ja sinut siirretään seuraavaan kysymykseen. Jos kysymykselle sallitaan uusintaottoja, sinun on vahvistettava uusintaotto tämän ajan sisällä.',
        goodLuck: 'Onnea haastatteluun!',
        qualityRating: {
          excellent: 'Erinomainen',
          good: 'Hyvä',
          fair: 'Kohtalainen',
          poor: 'Heikko',
          bad: 'Huono',
        },
      },
      questionAnswerView: {
        title: title => `Vastaa haastatteluun ${title}`,
        question: 'Kysymys',
        submitAndNext: 'Lähetä & seuraavaan',
        submitAndFinish: 'Lähetä & päätä haastattelu',
        submitSuccess: 'Video lähetetty onnistuneesti!',
        stop: 'Pysäytä',
        retake: 'Nauhoita uudelleen',
        take: 'Otto',
        takesLeft: 'Ottoja jäljellä',
        skipText: 'Aloita nauhoitus',
        skipTextQuestion: 'Valmis? Siirry eteenpäin',
        retakeConfirmTitle: 'Oletko varma että haluat nauhoittaa vastauksesi tähän kysymykseen uudelleen?',
        retakeConfirmSubmit: 'Kyllä, nauhoita vastaus uudelleen',
        submitInfoForward: 'Lähetetään tämänhetkinen vastaus automaattisesti ja siirrytään eteenpäin',
        submitInfoForward2: 'sekunnin kuluttua.',
        nonAnswerableText: 'Tähän viestiin ei tarvitse vastata. Tämän viestin jälkeen sinut siirretään suoraan seuraavaan kysymykseen.',
        nonAnswerableVideo: 'Tähän videoon ei tarvitse vastata. Tämän videon jälkeen sinut siirretään suoraan seuraavaan kysymykseen.',
        answerTimeInfo: (answerMinutes, answerSeconds) =>
          `Sinulla on ${answerMinutes} minuuttia ${answerSeconds} sekuntia aikaa vastata kysymykseen.`,
      },
      publisher: {
        toNextQuestion: timer => `Siirrytään seuraavaan kysymykseen ${timer} kuluttua`,
        recordingStarts: timer => `Nauhoitus alkaa ${timer} kuluttua`,
      },
      errors: {
        tooManyConnections: 'Tämä yhteys suljettiin, koska yhteys on jo muodostettu toisessa välilehdessä tai ikkunassa.',
        networkError: 'Ei Internet-yhteyttä.',
        reconnecting: 'Yhteyden muodostus epäonnistui. Yritetään muodostaa yheyttä uudelleen.',
        generalError: 'Jotain meni pieleen. Päivitä sivu ja yritä uudelleen.',
        unsupportedBrowser: 'Tämä toiminto ei ole valitettavasti tuettu käyttämälläsi selaimella.',
        qualityErrorText: 'Yhteytesi on tällä hetkellä heikko, mikä saattaa vaikuttaa äänen ja kuvan laatuun. Jos mahdollista, käytä toista internetyhteyttä.',
        allowMediaDevicesError: 'Emme löytäneet kameraa tai mikrofonia. Varmista, että olet sallinut selaimelle kameran ja mikrofonin käytön.',
        noAvailableDevicesError: 'Emme löytäneet kameraa tai mikrofonia. Varmista, että olet sallinut selaimelle kameran ja mikrofonin käytön ja että ne eivät ole käytössä jossain toisessa sovelluksessa ja yritä uudelleen.',
        initPublisherError: 'Ilmeni ongelma, jonka vuoksi toiminto epäonnistui. Varmista, että olet sallinut selaimelle kameran ja mikrofonin käytön ja että ne eivät ole käytössä jossain toisessa sovelluksessa ja yritä uudelleen.',
      },
      browserInfo: {
        browserSupportTitle: 'Tuetut selaimet',
        supportedBrowsers: 'Seuraavat selaimet ovat tässä testissä ja haastattelussa tuettuina: Chrome, Firefox, Safari ja Edge.',
        mobileSupported: 'Tuetut selaimet mobiililaitteilla',
        android: 'Android: Google Chrome (viimeisin julkaistu versio), Firefox (viimeisin julkaistu versio)',
        iOS: 'iOS: Safari (viimeisin julkaistu versio)',
        latestVersion: 'Valitsemalla käyttämästäsi selaimesta uusimman version varmistamme, että haastattelusi sujuu ongelmitta.',
        freezeInstruction: 'Jos videon nauhoitus ei ala, tai nauhoitusruutu pysyy mustana lataa sivu uudelleen.',
        unsupportedOnIos: 'Näyttää siltä, että käytät iOS-laitteella selainta, jota ei ole tuettu. Käytäthän Safaria.',
        ieUnsupported: 'Näyttää siltä että käytät Internet Explorer -selainta. Valitettavasti Internet Explorer ei ole tuettu selain tämän testin tai haastattelun suorittamiseen. Käytäthän jotain toista selainta.',
        qualityTestNotSupported: 'Kuvan ja äänen laadun testaaminen ei ole valitettavasti tuettu käyttämälläsi selaimella. Voit jatkaa haastatteluun ilman kuvan ja äänen testausta tai vaihtoehtoisesti vaihtaa johonkin toiseen selaimeen.',
      },
      reconnectSuccess: 'Yhteyden uudelleenmuodostus onnistui!',
      continue: 'Jatka',
    },

    withdraw: {
      title: 'Etkö ole enää kiinnostunut tästä positiosta?',
      description: 'Vetäydy rekrytointiprosessista.',
      buttonText: 'Vetäydy prosessista',
      thankYouTitle: 'Kiitos!',
      thankYouText: 'Olet nyt ilmoittanut rekrytoijille, ettet ole enää kiinnostunut positiosta.',
      confirm: 'Oletko varma että haluat vetäytyä tästä rekrytoinnista? Tämän jälkeen et pysty enää vastaamaan tähän haastatteluun tai muihin haastatteluihin, jotka on liitetty tähän positioon.',
    },
  },

  page: {
    embeddedProfileInterview: {
      submit: 'Tallenna & lähetä',
      continue: 'Jatka',
      supportCenter: 'Recright-tukisivusto',
      thankYou:
        'Videovastauksesi on lähetetty onnistuneesti. Kiitos vastauksestasi!',
    },

    supportLink: 'support@recright.com',

    finished: {
      title: 'Kiitos osallistumisestasi haastatteluun!',
      reopenDescription: 'Jos päätit haastattelun vahingossa, ei huolta! Voit avata haastattelun uudelleen alla olevasta napista!',
      reopenButtonText: 'Avaa haastattelu uudelleen',
      description1: 'Hienoa! Vastasit onnistuneesti haastatteluun ja vastauksesi lähetettiin rekrytoijan käsiteltäväksi.',
      descriptionsupport: mailto => `Jos päätit haastattelun vahingossa, ota yhteyttä tukeen ${mailto} ja avaamme haastattelusi.`,
      descriptionfeedback: 'Kokemuksesi videohaastatteluun vastaamisesta on meille tärkeä! Miltä videohaastatteluun vastaaminen tuntui? Mitä kehittäisit palvelussamme? Arvostele videohaastattelutyökalu ja anna palautetta.',
      feedbackbutton: 'Anna palautetta!',
      regularUrl: 'https://fi.surveymonkey.com/r/B3P3G7X',
      timedUrl: 'https://fi.surveymonkey.com/r/B36TV2M',
    },
    messages: {
      title: 'Henkilökohtainen viesti',
    },

    closed: {
      title: 'Olet vastannut haastatteluun tai haastattelu on päättynyt',
      description: 'Videohaastattelu johot sinut kutsuttiin on jo päättynyt tai olet jo vastannut haastatteluun.',
      publicTitle: 'Haastattelu on päättynyt',
      publicDescription: 'Videohaastattelu, jota etsit, on jo päättynyt.',
    },
    saved: {
      title: 'Haastattelu on tallennettu!',
      description: 'Nauhoittamasi videot ovat tallessa ja pääset jatkamaan videohaastatteluun vastaamista sähköpostiisi aikaisemmin tulleen linkin kautta. Onnea työnhakuun!',
      remember: 'Muistathan lähettää videovastaukset työnantajalle kun olet valmis!',
      deleteHistory: 'Jos teet videohaastattelua julkisella tietokoneella, muista tyhjentää selainhistoriasi, jotta haastattelusi on turvassa ulkopuolisilta.',
    },
    unpublished: {
      title: 'Haastattelu ei ole vielä avautunut',
      publishTime: publishTime => `Haastattelu avautuu ${publishTime}`,
    },
  },
}
